import { render, staticRenderFns } from "./DropdownCheckbox.vue?vue&type=template&id=2d345470"
import script from "./DropdownCheckbox.vue?vue&type=script&lang=js"
export * from "./DropdownCheckbox.vue?vue&type=script&lang=js"
import style0 from "./DropdownCheckbox.vue?vue&type=style&index=0&id=2d345470&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports